<template>
    <div class="preview-wrapper" v-show="isShow" @click="close($event)" @touchmove.stop.prevent="stopTouch($event)">
        <div class="preview-header">
            <i class="preview-header-icon icon-back"></i>
            <div class="preview-img-title">{{title}}</div>
        </div>
      <div class="preview-loading" v-show="isShowLoading">
        <div v-show="isShowLoading"></div>
      </div>
      <transition name="fade">
      <img
        @touchstart.stop="touchstart($event)"
        @touchend.stop="touchend($event)"
        class="preview-img"
        v-if="!isShowLoading"
        :src="url"
        :alt="title"
        v-show="!isShowLoading"
      >
      </transition>
      <span v-show="this.imgsList.length" class="preview-page">{{page}}</span>
    </div>

</template>

<script>
  import store from 'store'
  import * as Util from 'util'

  export default {
    name: 'Preview',
    data () {
      return {
        isShowLoading: false,
        url: '',
        isShow: false,
        title: ``,
        startX: ``,
        startY: ``,
        endX: ``,
        endY: ``,
        currentIndex: ``,
        imgsList: [],
        page: ''
      }
    },
    props: {
      isStartPreview: Boolean,
      datas: Object
    },
    computed: {},
    watch: {
      isStartPreview: function (val, oldVal) {
        this.title = val
        this.isShow = val
        if (val === true) {
          this.url = this.getPreviewUrl(this.datas)
          this.currentNeid = this.datas.neid
          var d = Util.resolvePath(this.datas.path, this.datas.is_dir)
          this.title = d.name
        }
        this.initImgsList()
      }
    },
    methods: {
      stopTouch (event) {
        return
      },
      initImgsList () {
        console.log(store.state.fileInfo.content)
        this.imgsList = store.state.fileInfo.content.filter(element => {
          return element.thumb_exist || element.thumbExist
        })
        console.log(this.imgsList)
        for (let i = 0; i < this.imgsList.length; i++) {
          if (this.imgsList[i].neid === this.datas.neid) {
            this.currentIndex = i
          }
        }
        this.page = this.currentIndex + 1 + '/' + this.imgsList.length
      },
      pre () {
        if (this.currentIndex + 1 < this.imgsList.length) {
          this.currentIndex++
        } else {
          this.currentIndex = 0
        }
        this.isShowLoading = true
        this.showImg()
      },
      next () {
        if (this.currentIndex !== 0) {
          this.currentIndex--
        } else {
          this.currentIndex = (this.imgsList.length - 1)
        }
        this.showImg()
      },
      showImg () {
        this.isShowLoading = true
        this.page = this.currentIndex + 1 + '/' + this.imgsList.length
        var newImg = new Image()
        let url = this.getPreviewUrl(this.imgsList[this.currentIndex])
        newImg.src = url
        newImg.onload = () => {
          this.url = url
          this.isShowLoading = false
          this.title = this.imgsList[this.currentIndex].name
        }
        newImg.error = () => {
          this.url = url
        }
      },
      getDirection (startx, starty, endx, endy) {
        var angx = endx - startx
        var angy = endy - starty
        var result = 0
        // 如果滑动距离太短
        if (Math.abs(angx) < 2 && Math.abs(angy) < 2) {
          return result
        }
        var angle = Math.atan2(angy, angx) * 180 / Math.PI
        if (angle >= -135 && angle <= -45) {
          result = 1
        } else if (angle > 45 && angle < 135) {
          result = 2
        } else if ((angle >= 135 && angle <= 180) || (angle >= -180 && angle < -135)) {
          result = 3
        } else if (angle >= -45 && angle <= 45) {
          result = 4
        }

        return result
      },
      touchstart (e) {
        if (this.imgsList.length === 0) {
          return
        }
        this.startx = e.touches[0].pageX
        this.starty = e.touches[0].pageY
        e.stopPropagation()
        e.preventDefault()
      },
      touchend (e) {
        console.log(`touchend ......`)
        let endx = e.changedTouches[0].pageX
        let endy = e.changedTouches[0].pageY
        var direction = this.getDirection(this.startx, this.starty, endx, endy)
        switch (direction) {
          case 0:
            console.log('未滑动！')
            break
          case 1:
            console.log('向上！')
            break
          case 2:
            console.log('向下！')
            break
          case 3:
            console.log('向左！')
            this.pre()
            break
          case 4:
            console.log('向右！')
            this.next()
            break
        }
      },
      getPreviewUrl (params) {
        var uri = '/v2/preview_router?type=pic&root=databox&path='
        if (params.isDelivery) {
          params.previewUrl = Util.getMyEncodeURI(params.previewUrl)
          uri = params.previewUrl
          if (params.path_type) {
            uri += '&path_type=' + params.path_type
          }
          if (params.delivery_token) {
            uri += '&delivery_token=' + params.delivery_token
          }
        } else {
          uri += Util.getMyEncodeURI(params.path)
        }
        if (params.path_type) {
          uri += '&path_type=' + params.path_type
        }
        if (params.from) {
          uri += '&from=' + params.from
        }
        if (params.neid) {
          uri += '&neid=' + params.neid
        }
        if (params.width) {
          uri += '&width=' + params.width
        }

        if (params.height) {
          uri += '&height=' + params.height
        }

        if (params.hash) {
          uri += '&hash=' + params.hash
        }

        if (params.rev) {
          uri += '&rev=' + params.rev
        }

        if (params.preview_type) {
          uri += '&preview_type=' + params.preview_type
        }
        if (Util.getCookie('S')) {
          uri += '&S=' + Util.getCookie('S')
        }
        if (Util.getCookie('X-LENOVO-SESS-ID')) {
          uri += '&X-LENOVO-SESS-ID=' + Util.getCookie('X-LENOVO-SESS-ID')
        }
        return uri
      },
      close (e) {
        this.isShow = false
        this.url = ``
        this.$emit('close')
      }
    }
  }
</script>

<style scoped>
  .preview-wrapper {
    position: fixed;
    width: 100%;
    height: 100%;
    text-align: center;
    box-sizing: border-box;
    background: rgba(0,0,0,0.5);
    z-index: 10000;
    top: 0;
  }

  .preview-loading {
    position: absolute;
    top: 45%;
    left: 50%;
    margin-left: -7.5px;
  }

  .preview-loading > div {
    background-color: #fff;
    width: 15px;
    height: 15px;
    border-radius: 100%;
    margin: 2px;
    -webkit-animation-fill-mode: both;
    animation-fill-mode: both;
    border: 2px solid #fff;
    border-bottom-color: transparent;
    height: 25px;
    width: 25px;
    background: transparent !important;
    display: inline-block;
    -webkit-animation: rotate 0.75s 0s linear infinite;
    animation: rotate 0.75s 0s linear infinite;
  }

  .preview-img {
    max-width: 100%;
    max-height: 93%;
    width: 100%;
    display: block;
    position: absolute;
    left: 0;
    top: 1.2rem;
    bottom: 0;
    right: 0;
    margin: auto;
  }

  .preview-header-icon {
    float: left;
    margin: 0 0 0 0.3rem;
    font-size: 0.67rem;
  }

  .preview-header {
      height: 0.9rem;
      text-align: center;
      color: #FFFFFF;
      font-size: 0.5rem;
      background: black;
      padding-top: 0.3rem;
  }

  .preview-page {
      position: absolute;
      bottom: 1rem;
      font-size: 0.4rem;
      color: #ffffff;
      left: 47%;
  }
  .preview-img-title {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    line-height: 0.6rem;
  }
</style>



// WEBPACK FOOTER //
// preview_img.vue?04d9a9c8